import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

interface AppHeaderActionsState {
  actions: React.ReactNode;
  setActions: (actions: React.ReactNode) => void;
}

const AppHeaderActionsContext = createContext<AppHeaderActionsState>({
  actions: null,
  setActions: () => {},
});

export function AppHeaderActionsProvider({ children }: React.PropsWithChildren) {
  const [actions, setActions] = useState<React.ReactNode>(null);
  const value = useMemo(() => ({ actions, setActions }), [actions]);

  return (
    <AppHeaderActionsContext.Provider value={value}>{children}</AppHeaderActionsContext.Provider>
  );
}

export function useAppHeaderActions(): React.ReactNode {
  return useContext(AppHeaderActionsContext).actions;
}

export function useAppHeaderAction(node: React.ReactNode): void {
  const { setActions } = useContext(AppHeaderActionsContext);

  useEffect(() => {
    setActions(node);
    return () => setActions(null);
  }, [node, setActions]);
}
